/** MASAR site contact & social — override via .env (see .env.example) */
export const SITE = {
  contactEmail:
    process.env.REACT_APP_CONTACT_EMAIL || "hello@masar.com",
  contactPhoneDisplay:
    process.env.REACT_APP_CONTACT_PHONE || "+966 59 324 9112",
  /** E.164 without spaces for tel: links */
  contactPhoneTel:
    process.env.REACT_APP_CONTACT_PHONE_TEL || "+966593249112",
  whatsappDigits:
    process.env.REACT_APP_WHATSAPP_NUMBER || "966593249112",
  linkedinUrl:
    process.env.REACT_APP_LINKEDIN_URL ||
    "https://www.linkedin.com/company/masar",
};
